import { render } from "./TabPanelFile.vue?vue&type=template&id=b93896c2"
import script from "./TabPanelFile.vue?vue&type=script&lang=js"
export * from "./TabPanelFile.vue?vue&type=script&lang=js"

import "./TabPanelFile.vue?vue&type=style&index=0&id=b93896c2&lang=css"
script.render = render

export default script